import {
  Box,
  Button,
  Group,
  Loader,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from '@mantine/core'
import { modals } from '@mantine/modals'

import { OrganizationDTOV2 } from '@workers-benefit-fund/api'
import { Icons } from 'src/common/components'

import styles from './CrossOrganizationNavigationModal.module.scss'

export interface CrossOrganizationNavigationModalProps {
  targetOrganization?: OrganizationDTOV2
  targetUrl: string
  hasAccess: boolean
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const CrossOrganizationNavigationModal = ({
  targetOrganization,
  hasAccess,
  isLoading = false,
  onConfirm,
  onCancel,
}: CrossOrganizationNavigationModalProps) => {
  return (
    <Box className={styles.container}>
      <Stack align="center" justify="center" my="md">
        <ThemeIcon size={80} radius="xl" variant="light">
          <Icons.Reload height="50" width="50" />
        </ThemeIcon>
        <Title order={3} c="primary">
          Switch Organization
        </Title>
      </Stack>

      {!hasAccess ? (
        <>
          <Text size="md" ta="center" mb="md">
            The URL you're trying to access belongs to an organization you don't
            have access to.
          </Text>
          <Text size="md" ta="center" mb="md" fw="bold">
            Sorry, you cannot access this resource.
          </Text>
          <Group justify="center">
            <Button onClick={onCancel} variant="filled" disabled={isLoading}>
              OK
            </Button>
          </Group>
        </>
      ) : (
        <>
          <Text size="md" ta="center" mb="md">
            The URL you're trying to access belongs to{' '}
            <Text size="lg" span fw="bold">
              {targetOrganization?.name || 'another organization'}
            </Text>
            . Are you sure you want to switch organizations?
          </Text>

          {isLoading && (
            <Group justify="center" mb="md">
              <Loader size="md" />
              <Text size="sm" c="dimmed">
                Switching organization...
              </Text>
            </Group>
          )}

          <Group justify="space-between">
            <Button onClick={onCancel} variant="outline" disabled={isLoading}>
              No, Stay Here
            </Button>
            <Button
              onClick={onConfirm}
              variant="filled"
              loading={isLoading}
              disabled={isLoading}
            >
              Yes, Switch
            </Button>
          </Group>
        </>
      )}
    </Box>
  )
}

export const showCrossOrganizationNavigationModal = (
  props: CrossOrganizationNavigationModalProps,
) => {
  modals.open({
    centered: true,
    children: <CrossOrganizationNavigationModal {...props} />,
    size: 'md',
    radius: 'md',
    withCloseButton: false,
    closeOnClickOutside: false,
    closeOnEscape: false,
    overlayProps: {
      backgroundOpacity: 0.85,
      blur: 9,
    },
  })
}
